import { render, staticRenderFns } from "./RewardDetail.vue?vue&type=template&id=55c685a9&scoped=true&"
import script from "./RewardDetail.vue?vue&type=script&lang=js&"
export * from "./RewardDetail.vue?vue&type=script&lang=js&"
import style0 from "./RewardDetail.vue?vue&type=style&index=0&id=55c685a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c685a9",
  null
  
)

export default component.exports